<template>
  <component :is="tag">
    <slot :convert="convert" />
  </component>
</template>

<script>
import { convertPrice } from "../../helpers";

export default {
  props: {
    tag: {
      type: String,
      default: "span",
    },
  },
  data() {
    return {
      currency: window.topNavStore.state.currency,
    };
  },
  mounted() {
    window.addEventListener("onCurrencyChanged", (e) => {
      this.currency = e.detail.currency;
    });
  },
  methods: {
    convert(value) {
      const price = convertPrice(this.currency.code, value);
      return `${this.currency.symbol}${price}`;
    },
  },
};
</script>
